import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { getUrlToBackendApi, request } from '@services/api';

import { GET_ME_QUERY_KEY } from '@hooks/api/user/use-query-me.ts';

const REQUEST_URL = '/logout';

const MUTATION_KEY = ['auth', 'logout'];

export const useMutationLogout = () => {
	const queryClient = useQueryClient();

	const navigate = useNavigate();

	return useMutation({
		mutationKey: MUTATION_KEY,
		mutationFn: async () => {
			try {
				return await request<void>({
					method: 'delete',
					url: getUrlToBackendApi(REQUEST_URL).href
				});
			} catch (error: any) {
				// Ignore 401 errors - user is already logged out
				if (error?.response?.status === 401 || error?.code === 401) {
					return;
				}
				throw error;
			}
		},
		onMutate: () => {
			// Clear tokens immediately
			localStorage.removeItem('auth_token');
			localStorage.removeItem('refresh_token');
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: GET_ME_QUERY_KEY });
			navigate('/', { replace: true });
		},
		onError: () => {
			// Even on error, ensure user is logged out locally
			queryClient.invalidateQueries({ queryKey: GET_ME_QUERY_KEY });
			navigate('/', { replace: true });
		}
	});
};
